import { initialsOf } from "../ds/Avatar";

/*
  Nav avatars (handoff "Avatar"): people are round, businesses are rounded
  squares. M 32, L 40.
*/
const SIZES = {
  m: "size-8 text-caption-1-semibold",
  l: "size-10 text-footnote-semibold",
};

const ShellAvatar = ({ src, name, size = "m", shape = "round", className = "" }) => {
  const shapeClass =
    shape === "round"
      ? "rounded-full bg-fill-secondary text-label-secondary"
      : `${size === "l" ? "rounded-radius-sm" : "rounded-radius-xs"} bg-fill-quaternary text-label-primary`;
  return (
    <span
      className={`relative flex shrink-0 items-center justify-center overflow-hidden ${SIZES[size]} ${shapeClass} ${className}`}
      aria-hidden="true"
    >
      {src ? <img src={src} alt="" className="h-full w-full object-cover" /> : initialsOf(name, shape === "round" ? 1 : 2)}
    </span>
  );
};

export default ShellAvatar;
